module.exports = __webpack_public_path__ + "img/2026-04_career-outcomes.8ae971e9.jpg";